// extracted by mini-css-extract-plugin
export default {"video-follow-btn":"ButtonFollow_video-follow-btn__0Vc8D","preview-follow-btn":"ButtonFollow_preview-follow-btn__UMvw1","profile-follow-btn":"ButtonFollow_profile-follow-btn__4URBP"};